import React from 'react';
import { Tabs } from 'antd';
import FavoritesTab from './FavoritesTab';
import BrandNameTab from './BrandNameTab'; // Импортируем новый компонент
import AnalogGeneratorTab from './AnalogGeneratorTab'; // Импортируем компонент генератора аналогов
import AiNamerTab from './AiNamerTab';

const Analyze = () => {
  const items = [
    {
      key: 'favorites',
      label: 'Избранное',
      children: <FavoritesTab />
    },
    {
      key: 'brand-generator',
      label: 'Нейминг',
      children: <BrandNameTab />
    },
    {
      key: 'analog-generator',
      label: 'Доработка обозначения',
      children: <AnalogGeneratorTab />
    },
    {
      key: 'ai-namer',
      label: 'ИИ-Неймер',
      children: <AiNamerTab />
    }
  ];

  return (
    <div className="tabs-container">
      <Tabs defaultActiveKey="favorites" className="custom-tabs" destroyInactiveTabPane={false} items={items} />
    </div>
  );
};

export default Analyze;
